import { Directive, EventEmitter, HostListener, Output } from '@angular/core';
import { timer, Subscription } from 'rxjs';

@Directive({
  selector: '[appLongPress]'
})
export class LongPressDirective {
  @Output() longPress = new EventEmitter<MouseEvent>();
  @Output() shortPress = new EventEmitter<MouseEvent>();
  private pressSubscription: Subscription | null = null;
  private isLongPress = false;

  @HostListener('mousedown', ['$event'])
  @HostListener('touchstart', ['$event'])
  onPressStart(event: MouseEvent): void {
    this.isLongPress = false;
    this.pressSubscription = timer(500).subscribe(() => {
      this.isLongPress = true;
      this.longPress.emit(event);
    });
  }

  @HostListener('mouseup', ['$event'])
  @HostListener('touchend', ['$event'])
  onPressEnd(event: MouseEvent): void {
    if (this.pressSubscription) {
      this.pressSubscription.unsubscribe();
      this.pressSubscription = null;
    }
    if (!this.isLongPress) {
      this.shortPress.emit(event);
    }
  }
}
